/* eslint-disable no-unused-vars */
import React from 'react';
import Navbarsection from '../views/Home/Navbarsection';
import Footersection from '../views/Home/Footersection';
import { Card } from 'flowbite-react';

const Whyus = () => {
    return (
        <>
       <Navbarsection/>
       
        <section>
      <h2 className="w-1/2 p-2 mt-4 text-orange-800 mx-auto text-center text-2xl font-bold sm:text-2xl"> Why Choose Sitekitpro   </h2>
      <br></br>
        <div className="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-11">
            <div className="grid gap-5 row-gap-5 sm:grid-cols-2 lg:grid-cols-4">
      
      
              <div className="px-12 text-left sm:px-0">
              <Card className=" " imgSrc="https://ik.imagekit.io/sitekitpro/assets/others/User-Friendly%20Interface.png" >
               
                <h6 className="mb-2 text-sm font-bold leading-5 tracking-wider uppercase">
                User-Friendly Interface
                </h6>
                <div className="mb-2 text-gray-700">
                SitekitPro intuitive tools and customization options enable users to tailor their website to their specific requirements swiftly, allowing for a personalized and professional web presence without the need for extensive technical knowledge.
                </div>
                </Card>
              </div>
      
              <div className="px-12 text-left sm:px-0">
              <Card className=" " imgSrc="https://ik.imagekit.io/sitekitpro/assets/others/Ready-to-Use%20Templates.png?updatedAt=1743860781395" >
              
                <h6 className="mb-2 text-sm font-bold leading-5 tracking-wider uppercase">
                Ready-to-Use Templates:
                </h6>
                <div className="mb-2 text-gray-700">
                With SitekitPro, the streamlined setup process enables users to deploy their custom readymade website in less than an hour, reducing time-to-market and providing a quick solution for those requiring an immediate online presence.
                </div>
                </Card>
              </div>
      
      
              <div className="px-12 text-left sm:px-0">
              <Card className=" " imgSrc="https://ik.imagekit.io/sitekitpro/assets/others/Quick%20Installation%20Process.png?updatedAt=1743860781012" >
              
                <h6 className="mb-2 text-sm font-bold leading-5 tracking-wider uppercase">
                Quick Installation Process: 
                </h6>
                <div className="mb-2 text-gray-700">
                SitekitPro platform offers easy integration with essential services and functionalities, ensuring that the websites setup and installation process is straightforward and fuss-free for users, regardless of their level of technical proficiency.
                </div>
                </Card>
              </div>
      
      
      
              <div className="px-12 text-left sm:px-0">
              <Card className=" " imgSrc="https://ik.imagekit.io/sitekitpro/assets/others/Efficient%20Support%20and%20Updates.png?updatedAt=1743860781072" >
                 
                <h6 className="mb-2 text-sm font-bold leading-5 tracking-wider uppercase">
                Efficient Support and Updates
                </h6>
                <div className="mb-2 text-gray-700">
                SitekitPro dedicated support team ensures that users can swiftly address any setup or installation issues that may arise, providing reassurance and guidance as users navigate the process of establishing their website within a short timeframe.
                </div>
                </Card>
              </div>
      
      
            </div>
          </div>
      </section>
      
       <Footersection/>
        </>
    );
}

export default Whyus;
